module.exports = __webpack_public_path__ + "img/phone.ef6708c3.svg";